import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { twofa as twofaApi } from '@afosto/iam/api/Twofa';
import StepBackUpMethods from './TwofaSteps/StepBackUpMethods/StepBackUpMethods';
import StepConnect from './TwofaSteps/StepConnect/StepConnect';
import StepSuccess from './TwofaSteps/StepFinished/StepFinished';

const TwofaSetupForm = ({ handleClose, currentStep, setCurrentStep, setActiveSecret }) => {
  const [qrCodeUrl, setQrCodeUrl] = useState(null);

  const onCreateSecret = async data => {
    const backUpMethods = [];

    if (data.email) {
      backUpMethods.push({ channel: 'email', address: data.email });
    }

    if (data.sms) {
      backUpMethods.push({ channel: 'sms', address: data.sms });
    }

    const body = {
      name: 'Afosto',
      backups: backUpMethods,
    };
    try {
      const response = await twofaApi.createSecret('login', body);
      const { data: { qr_url: qrUrl } = {} } = response;
      setQrCodeUrl(qrUrl);
      setActiveSecret(response.data);
      setCurrentStep('connect');
      return response;
    } catch (err) {
      return Promise.reject(err);
    }
  };
  const onVerifySecret = async formData => {
    try {
      const response = await twofaApi.verifyToken('login', formData);
      const { data: { is_verified: isVerified } = {} } = response;
      if (isVerified) {
        setCurrentStep('success');
      }
      return response;
    } catch (err) {
      return Promise.reject(err);
    }
  };

  return (
    <div>
      {currentStep === 'backup' && <StepBackUpMethods onSubmit={onCreateSecret} />}
      {currentStep === 'connect' && <StepConnect onSubmit={onVerifySecret} qrCodeUrl={qrCodeUrl} />}
      {currentStep === 'success' && <StepSuccess onClick={handleClose} />}
    </div>
  );
};

TwofaSetupForm.propTypes = {
  currentStep: PropTypes.oneOf(['backup', 'connect', 'success']),
  handleClose: PropTypes.func,
  setCurrentStep: PropTypes.func,
  setActiveSecret: PropTypes.func,
};

TwofaSetupForm.defaultProps = {
  currentStep: 'backup',
  handleClose: undefined,
  setCurrentStep: undefined,
  setActiveSecret: undefined,
};

export default TwofaSetupForm;
